import React, { Component, Fragment } from 'react';
import Header from './Header';
import _ from 'lodash';
import Table from './Table';
import { getPaymentStatus } from '../utils/PaymentRequestApiUtils';
import { editBufRejectedVendor, rejectBufRejectedVendor } from '../utils/VendorApiUtils';
import RaisedButton from 'material-ui/RaisedButton';
import { TextField, Button, Snackbar, LinearProgress,
    Dialog, DialogContent, DialogActions, DialogTitle,DialogContentText
} from '@material-ui/core';
import { viewFile } from './viewFileUtilFunction';
import userdata from '../config/jwt_token'
const errorText = 'This field is required'


const probable_columns = [
  {
    Header: 'PR Index',
    key: 'payment_request_id'
  },
  {
      Header: 'Upload Date',
      key: 'transaction_date'
  },
  {
      Header: 'RSN',
      key: 'buf_id'
  },
  {
      Header: 'Requestor',
      key: 'requestor_name'
  },
  {
      Header: 'Approver',
      key: 'approver_name'
  },
  {
      Header: 'Zolo Property Name',
      key: 'cost_center'
  },
  {
      Header: 'Vendor Code',
      key: 'vendor_code'
  },
  {
      Header: 'Vendor Name',
      key: 'vendor_name'
  },
  {
      Header: 'Payment Code',
      key: 'payment_request_code'
  },
  {
      Header: 'Expenditure-Category',
      key: 'ledger_name'
  },
  {
      Header: 'Description',
      key: 'narration'
  },
  //Category
  {
      Header: 'Entity',
      key: 'type'
  },
  {
      Header: 'Invoice (Without GST) Amount',
      key: 'total_invoice_amount'
  },
  {
      Header: 'GST',
      key: 'gst_total'
  },
  {
      Header: 'Invoice Amount',
      key: 'invoice_amount_with_gst'
  },
  {
      Header: 'TDS',
      key: 'total_tds_deduction'
  },
  {
      Header: 'Other Deductions',
      key: 'total_deduction_others'
  },
  {
      Header: 'Advance Paid',
      key: 'advance_paid'
  },
  {
      Header: 'Net Payment',
      key: 'total_payable_amount'
  },
  {
      Header: 'Total PO Amount',
      key: 'full_invoice_amount_display'
  },
  {
      Header: 'Section',
      key: 'it_section_applicable'
  },
  {
      Header: 'City',
      key: 'city'
  },
  {
      Header: 'Tally Narration',
      key: 'tally_narration'
  },
  {
      Header: 'Bene A/c No.',
      key: 'bank_acc_number'
  },
  {
      Header: 'Bene Name',
      key: 'beneficiary_name'
  },
  {
    Header: 'Customer Ref No',
    key: 'cust_ref_number'
  },
  {
      Header: 'IFSC code',
      key: 'ifsc_code'
  },
  {
      Header: 'Bene Bank Name',
      key: 'bank_name'
  },
  {
      Header: 'TXN ID',
      key: 'transaction_id'
  },
  {
      Header: 'TXN Date',
      key: 'transaction_date'
  },
  {
      Header: 'Status',
      key: 'transaction_status'
  },
  {
      Header: 'Attachment',
      key: 'invoice_soft_copy_link'
  },
  {
    Header: 'Supporting Document',
    key: 'supporting_document_link'
  },
  {
      Header: 'Property Code',
      key: 'zolo_code'
  },
  {
      Header: 'Invoice/PO No.',
      key: 'invoice_or_po'
  },
  {
      Header: 'Invoice Date',
      key: 'date_of_invoice'
  },
  {
      Header: 'EXP FTM',
      key: 'expenditure_month'
  },
  {
      Header: 'Recoverable',
      key: 'is_recoverable'
  }
]

const vendor_action = [{
  Header: 'Vendor Actions',
  key: 'vendor_actions',
  filterable: false,
}]
const COLUMNS = (userdata && userdata.role === 'Super Central Finance')?[...vendor_action, ...probable_columns]:probable_columns;

class BufRejectedPayments extends Component{
    constructor(){
        super();
        this.state = {
            selectedVendorData: {
              vendor_buffer_id: '',
              beneficiary_name: '',
              bank_acc_number: '',
              confirm_bank_acc_number: '',
              ifsc_code: '',
              bank_name: '',
              cancel_cheque_upload_file: null,
              vendor_code: '',
            },
            data: [],
            snackMessage: '',
            snackOpen: false,
            dialogBoxText: "",
            successdialogBoxText: "",
            successdialogBox: false,
            rejectDialogBox: false,
            rejectDialogBoxText: "",
            confirm_bank_acc_numberErrText: '',
            confirm_bank_acc_numberErr: false,      
            bank_acc_numberErrText: '',
            bank_acc_numberErr: false,
            ifsc_codeErrText: '',
            ifsc_codeErr: false,
            bank_nameErrText: '',
            bank_nameErr: false,
            showBankAplhaNumDialog: false,
            bankACIsAlphaNumeric: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleCloseSuccessDialogBox = this.handleCloseSuccessDialogBox.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCloseSnack = this.handleCloseSnack.bind(this);
        this.handleFetchData = this.handleFetchData.bind(this);
    }

    componentDidMount(){
        this.handleFetchData()
    }
    handleFetchData(){
      let filters = {state: 'Failed'}
      getPaymentStatus(filters).then(response => {
            if (response) {
              if (response.status === 'success') {
                let data = response.data.map((data, index) => {
                  return { ...data,
                    full_invoice_amount_display: (data.partial_payment_percentage && data.full_invoice_amount) ? data.full_invoice_amount : '-',
                    vendor_actions:
                    <div>
                      <RaisedButton label="Edit" primary={true} disabled={userdata.role === 'Super Central Finance'?false:true} onClick={this.handleEditClick.bind(this, 'edit', index)}>
                      </RaisedButton>
                      <RaisedButton label="Reject" style={{ marginLeft: '20px'}} secondary={true} disabled={userdata.role === 'Super Central Finance'?false:true} onClick={this.handleEditClick.bind(this, 'reject', index)}>
                      </RaisedButton>
                    </div>
                  }
                })
                this.setState({ data })
              }
              else {
                this.setState({ snackMessage: response.message, snackOpen: true })
              }
            }
        })
    }
    handleChange = (props) => (event, index, value) => {
      if (props === 'bank_acc_number') {
        let ac_number = event.target.value;
        let letters = /^[A-Za-z]$/
        let myregexAlphaNum = /^[A-Za-z0-9]{0,18}$/
        //for resetting behaviour when blank
        if(ac_number === '')
          this.setState({bankACIsAlphaNumeric: false})
          
        //for catching an alphabetic entry to display the pop-up
        if (letters.test(event.target.value.slice(-1)) && this.state.bankACIsAlphaNumeric === false){
            this.setState({bankACIsAlphaNumeric: true, showBankAplhaNumDialog: true})
          }
        if (!myregexAlphaNum.test(ac_number)) {
          this.setState({ snackMessage: 'Invalid Bank number', snackOpen: true })
          return
        }
        else {
          this.setState({ selectedVendorData: { ...this.state.selectedVendorData, [props]: ac_number }, [props + 'ErrText']: '', [props + 'Err']: false })
        }
      }
      else if (props === 'confirm_bank_acc_number') {
        let myregexAlphaNum = /^[A-Za-z0-9]{0,18}$/
        if (!myregexAlphaNum.test(event.target.value)) {
          this.setState({ snackMessage: 'Invalid Bank number in Confirm Field', snackOpen: true })
          return
        }
        else {
          this.setState({ selectedVendorData: { ...this.state.selectedVendorData, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: false })
        }
      }
      else if (props === 'ifsc_code') {
        let myRegxp = /^([a-zA-Z0-9_-]){0,11}$/;
        if (!myRegxp.test(event.target.value)) {
          this.setState({ snackMessage: "Invalid IFSC Code", snackOpen: true })
          return
        }
        else {
          this.setState({ selectedVendorData: { ...this.state.selectedVendorData, [props]: event.target.value.toUpperCase() }, [props + 'ErrText']: '', [props + 'Err']: false })
        }
      }
      else {
        this.setState({ selectedVendorData: { ...this.state.selectedVendorData, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: false })
      }
    }

    handleClick = (props) => (event, index, value) => {
      if (props !== 'bank_acc_number' && this.state.selectedVendorData.bank_acc_number !== '') {
        if (this.state.selectedVendorData.bank_acc_number.length < 6) {
          this.setState({ bank_acc_numberErrText: 'Invalid number (Max length is 6-18) ', bank_acc_numberErr: true })
        }
      }
      if (props !== 'confirm_bank_acc_number' && this.state.selectedVendorData.confirm_bank_acc_number !== '' && this.state.selectedVendorData.confirm_bank_acc_number) {
        if (this.state.selectedVendorData.confirm_bank_acc_number.length < 6) {
          this.setState({ confirm_bank_acc_numberErrText: 'Invalid number (Max length is 6-18) ', confirm_bank_acc_numberErr: true })
        }
      }
      if (props !== 'ifsc_code' && this.state.selectedVendorData.ifsc_code !== '') {
        if (this.state.selectedVendorData.ifsc_code.length !== 11) {
          this.setState({ ifsc_codeErrText: 'Invalid IFSC Code (length should be 11 characters) ', ifsc_codeErr: true })
        }
      }
    }
    handleClear() {
      let currentRecord = this.state.selectedVendorData;
      this.setState({
        bankACIsAlphaNumeric: false,
        selectedVendorData: {
          vendor_buffer_id: currentRecord.vendor_buffer_id,
          beneficiary_name: currentRecord.beneficiary_name,
          bank_acc_number: '',
          ifsc_code: '',
          bank_name: '',
          confirm_bank_acc_number: '',
          cancel_cheque_upload_file: currentRecord.cancel_cheque_upload_file
        }
      })
  
    }

    handleEditClick(value, index, event) {
      let selectedRecord = this.state.data[index];
        let paymentIdsFromSameVendor = this.state.data.filter((datum) => {
          return datum.vendor_buffer_id === selectedRecord.vendor_buffer_id
        }).map((ele => {return {payment_request_id: ele.payment_request_id, buf_id: ele.buf_id}}))

      if (value === 'edit') {
        this.setState({
          selectedVendorData: {
            vendor_buffer_id: selectedRecord.vendor_buffer_id,
            beneficiary_name: selectedRecord.beneficiary_name,
            bank_acc_number: selectedRecord.bank_acc_number,
            confirm_bank_acc_number: selectedRecord.bank_acc_number,
            ifsc_code: selectedRecord.ifsc_code,
            bank_name: selectedRecord.bank_name,
            cancel_cheque_upload_file: selectedRecord.cancel_cheque_upload_file,
            paymentIdsFromSameVendor: paymentIdsFromSameVendor,
            vendor_code: selectedRecord.vendor_code,
          },
          dialogOpen: true, dialogBoxText: "Handle vendor edit" 
        })
      }
      if (value === 'reject') {
        this.setState({
          selectedVendorData: {
            vendor_buffer_id: selectedRecord.vendor_buffer_id,
            beneficiary_name: selectedRecord.beneficiary_name,
            bank_acc_number: selectedRecord.bank_acc_number,
            confirm_bank_acc_number: selectedRecord.bank_acc_number,
            ifsc_code: selectedRecord.ifsc_code,
            bank_name: selectedRecord.bank_name,
            cancel_cheque_upload_file: selectedRecord.cancel_cheque_upload_file,
            paymentIdsFromSameVendor: paymentIdsFromSameVendor,
            vendor_code: selectedRecord.vendor_code,
          },
          rejectDialogBox: true,
          rejectDialogBoxText: "The vendor and corresponding payments will be blocked",
        })
      }
      if (value === 'info') {
        
      }
    }
    handleDelete(index, event, value) {

    }
    

    handleClose() {
        this.setState({ dialogOpen: false, dialogBoxText: "" })
    }
    handleCloseSnack = () =>{
      this.setState({ snackOpen: false });
    }
    handleSubmit() {
        if (this.state.selectedVendorData.bank_acc_number === '') {
          this.setState({ bank_acc_numberErrText: errorText, bank_acc_numberErr: true })
        }
        if (this.state.selectedVendorData.ifsc_code === '') {
          this.setState({ ifsc_codeErrText: errorText, ifsc_codeErr: true })
        }
        if (this.state.selectedVendorData.bank_name === '') {
          this.setState({ bank_nameErrText: errorText, bank_nameErr: true })
        }
        if (this.state.selectedVendorData.bank_acc_number !== '') {
          let myregex = /^[A-Za-z0-9]{6,18}$/
          if (!myregex.test(this.state.selectedVendorData.bank_acc_number)) {
            this.setState({ snackMessage: 'Invalid Bank Account number', snackOpen: true })
            return
          }
        }
        if (this.state.selectedVendorData.bank_acc_number !== this.state.selectedVendorData.confirm_bank_acc_number) {
          this.setState({ snackMessage: 'Bank account number did not match ', snackOpen: true })
          return
        }
        if (this.state.selectedVendorData.ifsc_code !== '') {
          let myRegxp = /^([a-zA-Z0-9_-]){11}$/;
          if (!myRegxp.test(this.state.selectedVendorData.ifsc_code)) {
            this.setState({ snackMessage: "IFSC length should be 11 characters", snackOpen: true })
            return
          }
        }
      if ((this.state.selectedVendorData.bank_acc_number !== '' && this.state.selectedVendorData.ifsc_code !== '' && this.state.selectedVendorData.bank_name !== '')) {
        this.moveToNext();
      }
    }
    moveToNext = () => {
      editBufRejectedVendor(JSON.stringify({editedVendorDetails: this.state.selectedVendorData})).then(
        response => {
          if(response.status === 'success'){
            if(response.data[0]){
              this.setState({ successDialogBox: true, successdialogBoxText: 'Vendor has been successfully edited' })
            }
            else
              this.setState({snackOpen: true, snackMessage: 'You did not make any changes'})
          }
          else
          this.setState({snackOpen: true, snackMessage: response.message}) 
        }
      )
    }

    handleBankAplhaNumDialogClose() {
      this.setState({showBankAplhaNumDialog: false})
    }
  
    handleBankAplhaNumDialogYes() {
      this.setState({showBankAplhaNumDialog: false})
    }
  
    handleBankAplhaNumDialogNo() {
      this.setState({showBankAplhaNumDialog: false, bankACIsAlphaNumeric: false, selectedVendorData:{ ...this.state.selectedVendorData, bank_acc_number: ''}})
    }
    handleCloseSuccessDialogBox(){
      this.setState({successDialogBox: false, successDialogBoxText: ""}, () => {
        window.location.reload();
      })
    }
    handleRejectDialogBox(){
      rejectBufRejectedVendor(JSON.stringify({vendorDetails: this.state.selectedVendorData})).then(
        response => {
          if(response.status === 'success'){
            this.setState({ rejectDialogBox: false, rejectDialogBoxText: "", snackOpen: true, snackMessage: 'Vendor has been successfully rejected' }, 
            () => {
              window.location.reload()
            })
          }
          else
          this.setState({snackOpen: true, snackMessage: response.message}) 
        }
      )

    }
    handleCloseRejectDialogBox(){
      this.setState({rejectDialogBox: false, rejectDialogBoxText: ""})
    }

    render(){
        return(
            <Fragment>
                <Header />
        <div className="zaps-page-wrap">
          <div className="zaps-page-header">
            <div>
              <h2 className="zaps-page-title">BUF Rejected Payments</h2>
              <p className="zaps-page-subtitle">Rejected payment files requiring attention</p>
            </div>
          </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px', flexWrap: 'wrap' }}>
                </div>
                <Table columns={COLUMNS} data={this.state.data} />

                <Dialog
                    open={this.state.dialogOpen}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                  <DialogContent>
                    <div style={{ display: 'flex', flexDirection:'column' }}>
                      <div style={{ display: 'flex', flexDirection:'row'}}>
                        <TextField
                          label="Beneficiary Name"
                          value={this.state.selectedVendorData.beneficiary_name}
                          style={{ width: '250px', marginRight: '8px' }}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <div style= {{width: '250px',marginLeft: '12px'}} > <span>Cancelled Cheque Copy : </span>
                        {this.state.selectedVendorData.cancel_cheque_upload_file?
                            <Button size="small" color="primary" variant="contained" onClick={()=>viewFile(this.state.selectedVendorData.cancel_cheque_upload_file)}>
                              View</Button> : <span>N.A.</span>
                        }
                        </div>
                      </div>
                      <div style={{ display: 'flex', flexDirection:'row'}}>
                        <TextField
                          label="*Bank Account Number"
                          placeholder="Enter Account Number"
                          value={this.state.selectedVendorData.bank_acc_number}
                          onChange={this.handleChange('bank_acc_number')}
                          onClick={this.handleClick('bank_acc_number')}
                          onCut={(event) => { event.preventDefault() }}
                          onCopy={(event) => { event.preventDefault() }}
                          onPaste={(event) => { event.preventDefault() }}
                          margin='normal'
                          style={{ width: '250px',marginRight: '8px' }}
                          helperText={this.state.bank_acc_numberErrText}
                          error={this.state.bank_acc_numberErr}/>
                        <br />
                        <TextField
                          label=" *Confirm Bank Account Number"
                          placeholder="Enter Account Number"
                          type='password'
                          value={this.state.selectedVendorData.confirm_bank_acc_number}
                          onChange={this.handleChange('confirm_bank_acc_number')}
                          onClick={this.handleClick('confirm_bank_acc_number')}
                          onCut={(event) => { event.preventDefault() }}
                          onCopy={(event) => { event.preventDefault() }}
                          onPaste={(event) => { event.preventDefault() }}
                          margin='normal'
                          style={{ width: '250px', marginLeft: '12px' }}/>
                        <br />
                      </div>
                      <div style={{ display: 'flex', flexDirection:'row'}}>
                        <TextField
                          label="*IFSC Code"
                          placeholder="Enter IFSC Code"
                          value={this.state.selectedVendorData.ifsc_code}
                          onChange={this.handleChange('ifsc_code')}
                          onClick={this.handleClick('ifsc_code')}
                          style={{ width: '250px', marginRight: '8px' }}
                          helperText={this.state.ifsc_codeErrText}
                          error={this.state.ifsc_codeErr}
                        />
                        <TextField
                          label="*Bank Name"
                          placeholder="Enter Bank Name"
                          value={this.state.selectedVendorData.bank_name}
                          onChange={this.handleChange('bank_name')}
                          onClick={this.handleClick('bank_name')}
                          style={{ width: '250px', marginLeft: '12px' }}
                          helperText={this.state.bank_nameErrText}
                          error={this.state.bank_nameErr}

                        />
                      </div>
                    </div> 
                    </DialogContent>
                    <DialogActions style={{justifyItems: 'center'}}>
                    <div>
                      <Button variant="contained" color="secondary" onClick={this.handleClose} >Cancel</Button>
                      <Button variant="contained" color="primary" onClick={this.handleClear} style={{ marginLeft: '20px', background: 'linear-gradient(135deg,#f59e0b,#d97706)' }}>Clear</Button>
                      <Button variant="contained" color="primary" onClick={this.handleSubmit} disabled={this.state.isInRequest} style={{ marginLeft: '20px' }}>Edit</Button>
                    </div>
                    </DialogActions>
                </Dialog>
                <Dialog
                  open={this.state.showBankAplhaNumDialog}
                  onClose={this.handleBankAplhaNumDialogClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogContent>
                    <DialogTitle id="alert-dialog-title">{"Alphanumeric Entry For A/C"}</DialogTitle>
                    <DialogContentText id="alert-dialog-description">
                    The A/C Number added is alpha-numeric. Are you sure the number is correct?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.handleBankAplhaNumDialogNo.bind(this)} color="primary">
                      No
                    </Button>
                    <Button onClick={this.handleBankAplhaNumDialogYes.bind(this)} color="primary" autoFocus>
                      Yes
                    </Button>
                  </DialogActions>
                </Dialog>
                <Dialog
                  modal={false}
                  open={this.state.successDialogBox}
                  onClose={this.handleCloseSuccessDialogBox.bind(this)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      <h4 style={{ textAlign: 'center' }}>{this.state.successdialogBoxText}</h4>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.handleCloseSuccessDialogBox.bind(this)} color="primary">
                      OK
                    </Button>
                  </DialogActions>
                </Dialog>
                <Dialog
                  modal={false}
                  open={this.state.rejectDialogBox}
                  onClose={this.handleCloseRejectDialogBox.bind(this)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <h4 style={{ textAlign: 'center' }}>{this.state.rejectDialogBoxText}</h4>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCloseRejectDialogBox.bind(this)} color="primary" autoFocus>
                      Cancel
                    </Button>
                    <Button onClick={this.handleRejectDialogBox.bind(this)} color="primary">
                      Continue
                    </Button>
                  </DialogActions>
                </Dialog>
                <Snackbar
                open={this.state.snackOpen}
                message={this.state.snackMessage}
                autoHideDuration={1000}
                onClose={this.handleCloseSnack.bind(this)}
                />
          
        </div>{/* end zaps-page-wrap */}
      </Fragment>
        )
    }
}

export default BufRejectedPayments;


// WEBPACK FOOTER //
// ./src/components/BufRejectedPayments.js